import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import { Box } from '@mui/material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { styled } from '@mui/material/styles';

import { history } from '../../store';

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: 'none',

  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.primary.main,
    zIndex: 2,
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  minWidth: 100,
  padding: '.6rem 2.4rem',
  fontWeight: theme.typography.fontWeightRegular,
  color: '#35343D',
  fontSize: '1.8rem',
  marginRight: theme.spacing(3),
  '&:hover': {
    color: theme.palette.primary.main,
    opacity: 1,
  },
  '&$selected': {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
  '&:focus': {
    color: theme.palette.primary.main,
  },
  [theme.breakpoints.down('sm')]: {
    padding: '1rem',
  },
}));

const StyledContainer = styled(Box)(({ theme }) => ({
  marginBottom: '2.5rem',
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '2rem',
  },
}));

const StyledBottomBorder = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  zIndex: 1,
  width: '100%',
  borderBottom: `.2rem solid ${theme.palette.grey[300]}`,
}));

const SecondLineTabs = (props) => {
  const { pathname } = useLocation();
  const { tabData, currentUrl } = props;
  const [path, setPath] = useState(currentUrl || false);
  if (!tabData?.length) return null;

  useEffect(() => setPath(currentUrl), [currentUrl]);

  const handleChange = (event, newValue) => {
    if (newValue === pathname) {
      event.preventDefault();
      return;
    }

    setPath(newValue);
    history.push(newValue);
  };

  return (
    <StyledContainer>
      <StyledTabs
        value={path}
        onChange={handleChange}
        aria-label="second-line-tabs"
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabData.map(({ url, label, disabled }) => (
          <StyledTab
            disableRipple
            value={url}
            label={label}
            key={url}
            disabled={disabled}
          />
        ))}
      </StyledTabs>
      <StyledBottomBorder />
    </StyledContainer>
  );
};

SecondLineTabs.propTypes = {
  tabData: PropTypes.instanceOf(Array).isRequired,
  currentUrl: PropTypes.string.isRequired,
};

export default SecondLineTabs;
